import type { HelpTranslationLinkMapKey } from '@core/help-articles-legacy';

export enum OnboardingVideoId {
  Brockmeyer = 'brockmeyerWatched',
  Careers = 'careersWatched',
  EvaluatingCandidates = 'evaluatingCandidatesWatched',
  Gdpr = 'gdprWatched',
  Manage = 'manageWatched',
  MeetRecruitee = 'meetRecruiteeWatched',
  Multilang = 'multilangWatched',
  ProfileFields = 'profileFieldsWatched',
  Reports = 'reportsWatched',
  Scheduler = 'schedulerWatched',
  TalentPools = 'talentPoolsWatched',
  Team = 'teamWatched',
  MobileApp = 'mobileAppWatched',
  PublishJob = 'publishJobWatched',
  PipelineCandidates = 'pipelineCandidatesWatched',
  PipelineOverview = 'pipelineOverviewWatched',
  FairEvaluations = 'fairEvaluationsWatched',
  KnockoutQuestions = 'knockoutQuestionsWatched',
  MarkAsHired = 'markAsHiredWatched',
  Requisitions = 'requisitionsWatched',
  RequisitionsOffer = 'requisitionsOfferWatched',
}

export interface OnboardingVideo {
  id: OnboardingVideoId;
  thumbnail: string;
  videoId: string;
  title: string;
  description: string;
  watched: boolean;
  time: number;
  displayTime: string;
  articleLinkKey?: HelpTranslationLinkMapKey;
}
